import isNil from 'lodash/isNil';

export function isDefined<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}

/**
 * isEqualWith customizer that treats null and undefined as equal.
 * Use when the compared projections express "unset" inconsistently.
 */
export const nullishAsEqual = (
  firstValue: unknown,
  secondValue: unknown
): boolean | undefined =>
  isNil(firstValue) || isNil(secondValue)
    ? isNil(firstValue) && isNil(secondValue)
    : undefined;
